export default function setValueTable(table, id, keyData, valData) {
    const item = table.find(invoice => invoice.id === id);
    if (!item) {
        console.error("Item not found in the table");
        return;
    }
    window.billing.put("invoice/editCampos", {
        user_idd: window.master_client,
        user_id: window.localuserdata,
        org_id: window.localorgdata,
        oauth_m: window.oauth_m,
        id: id,
        keyData: keyData,
        valData: valData,
        socket_id: pusher.connection.socket_id,
    })
    .then((response) => {
        if (response.data.status) {
            console.log("Data updated successfully");
            if(keyData === "idxstatus") {
                let isPending = this.isOverdue(valData, item.fecdue);
                if(isPending != valData) {
                    valData = isPending; // Update valData if idxstatus is changed to overdue
                }
            }
            // console.log("updateDataList", table, id, {[keyData]: valData}, [keyData]);
            this.updateDataList(table, id, {[keyData]: valData}, [keyData]);
        } else {
            console.error("Error updating data:", response.data.message);
        }
    })
    .catch((error) => {
        console.log(error);
    });
};